import { SentenceType } from 'types/types'
import { computed, Ref } from 'vue'
import { VueLogger } from 'vue-logger-plugin'

import { RESET_TO_SENTENCE, RESET_TO_WORDS } from '@/constants/practiceConstants'
import { AnnotatedSentence } from '@/util/AnnotatedSentence'

const useSegmentation = (segmentation: Ref<Array<number>>, preSentences: Ref<Array<SentenceType>>, logger: VueLogger) => {
  const segmentations = computed<Array<Array<number>>>((): Array<Array<number>> => {
    logger.debug('computed segmentations; segmentation = ')
    logger.debug(segmentation.value)
    let ss = [segmentation.value].filter(Boolean)

    // this is to ensure that if there are surrounding sentences, the
    // segmentation information is shifted forward in the array. In other
    // words, if surround == 2, then the segmented sentences we care about
    // needs to be 3rd in the arary; we prepend bogus [] entries in the array
    // before the ss entry
    if (preSentences.value?.length) {
      ss = new Array(preSentences.value.length).fill([]).concat(ss)
    }

    return ss
  })

  function resetSegments(how = RESET_TO_WORDS, annotatedSentence: Ref<AnnotatedSentence | null>): void {
    if (!annotatedSentence.value) {
      return
    }
    if (how === RESET_TO_SENTENCE) {
      segmentation.value = makeSentenceSegmentation(annotatedSentence.value)
    } else if (how === RESET_TO_WORDS) {
      segmentation.value = makeWordSegmentation(annotatedSentence.value)
    }
  }

  return {
    resetSegments,
    segmentations,
  }
}

// Pure factories: create standard segmentation patterns
const makeWordSegmentation = (annotatedSentence: AnnotatedSentence): number[] => Array(annotatedSentence.nWords()).fill(1)

const makeSentenceSegmentation = (annotatedSentence: AnnotatedSentence): number[] => [annotatedSentence.nWords()]

// Pure checks: does this segmentation match the standard (default) pattern?
const isWordSegmentation = (segmentation: number[], nWords: number): boolean => segmentation.length === nWords

const isFullSentenceSegmentation = (segmentation: number[], nWords: number): boolean =>
  segmentation.length === 1 && segmentation[0] === nWords

export { isFullSentenceSegmentation, isWordSegmentation, makeSentenceSegmentation, makeWordSegmentation, useSegmentation }
